<template>
  <div>
    <NuxtLoadingIndicator color="#111" />
    <NuxtLayout>
      <div>
        <NuxtPage :keepalive="shouldKeepalive" :page-key="route=>route.fullPath" />
      </div>
    </NuxtLayout>
  </div>
</template>
<script setup>
const config = useRuntimeConfig()
const route = useRoute()

const shouldKeepalive = computed(() => {
  return route.name && (route.name.includes('product-slug-id') || ['nl-slug', 'de-slug', 'en-slug'].includes(route.name))
})

useDefaultMeta()
useHead({
  meta: [
    { charset: 'utf-8' },
    {
      key: 'viewport',
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, viewport-fit=cover'
    },
    {
      'http-equiv': 'expires',
      content: '0'
    },
    {
      name: 'HandheldFriendly',
      content: 'true'
    },
    {
      name: 'robots',
      content: config.public.stage !== 'live' ? 'noindex' : ''
    },
    { key: 'fb:app_id', property: 'fb:app_id', content: '634057110108374' },
    { key: 'fb:admins', property: 'fb:admins', content: '100001098197139' }
  ],
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
    {
      rel: 'search',
      href: '/open-search.xml',
      title: 'Guts & gusto',
      type: 'application/opensearchdescription+xml'
    },
    {
      rel: 'preload',
      href: '/fonts/guts-guts-bold.woff2',
      as: 'font',
      crossorigin: 'anonymous'
    },
    {
      rel: 'preload',
      href: '/fonts/guts-guts-middle.woff2',
      as: 'font',
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: config.public.cdnURL || 'https://cdn.gutsgusto.com/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: 'https://connect.facebook.net/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: 'https://www.googletagmanager.com/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'dns-prefetch',
      href: 'https://www.gstatic.com/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'dns-prefetch',
      href: 'https://www.google.com/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'dns-prefetch',
      href: config.public.bunnyVideoURL,
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: 'https://www.gstatic.com/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: 'https://www.google.com/',
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: config.public.bunnyVideoURL,
      crossorigin: 'anonymous'
    },
    {
      rel: 'preconnect',
      href: config.public.baseURL,
      crossorigin: 'anonymous'
    },
    {
      rel: 'dns-prefetch',
      href: config.public.cdnURL || 'https://cdn.gutsgusto.com/',
      crossorigin: 'anonymous'
    }
  ]
})
</script>
<style lang="scss">
@use '@/scss/reset';
@use '@/scss/css-variables.css';
@use '@/scss/font';
@use '@/scss/typography';
@use '@/scss/base';
@use '@/scss/helpers';
@use '@/scss/container';
@use '@/scss/pages';
@use '@/scss/table';
@use '@/scss/animations';
</style>
